import { render, staticRenderFns } from "./GlobalSearchFilteredDestination.vue?vue&type=template&id=a2317c2e&"
import script from "./GlobalSearchFilteredDestination.vue?vue&type=script&lang=ts&"
export * from "./GlobalSearchFilteredDestination.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports